Customer.Reports ||= {}

class Customer.Reports.PieReport

  constructor: (@json, @container) ->

  render: ->
    new Highcharts.Chart(@_getOptions())
    return this

  _getOptions: ->
    return new Customer.Reports.PieOptions(
      container: @container
      height: 500
      width: 900
      data: @json.data
    ).get()
